import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { keyframes } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { B50, N30, N40, N50, N60 } from '@atlaskit/theme/colors';
var placeholderShimmer = keyframes({
  '0%': {
    backgroundPosition: '-20px 0'
  },
  '100%': {
    backgroundPosition: '60px 0'
  }
});
var appearanceValues = {
  darkGray: {
    background: "var(--ds-background-accent-gray-subtler, ".concat(N50, ")"),
    animation: "var(--ds-background-accent-gray-subtle, ".concat(N60, ")")
  },
  gray: {
    background: "var(--ds-background-accent-gray-subtlest, ".concat(N30, ")"),
    animation: "var(--ds-skeleton, ".concat(N40, ")")
  },
  blue: {
    background: "var(--ds-background-accent-blue-subtlest, ".concat(B50, ")"),
    animation: "var(--ds-background-information-hovered, #cce0ff)"
  }
};

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var ShimmerSkeleton = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\theight: ", ";\n\twidth: ", ";\n\tborder-radius: ", ";\n\tuser-select: none;\n\tbackground: ", ";\n\n\tbackground-image: ", ";\n\tbackground-repeat: no-repeat;\n\tbackground-size: ", ";\n\n\tanimation: ", " 1s linear infinite forwards;\n"])), function (_ref) {
  var height = _ref.height;
  return height || 'auto';
}, function (_ref2) {
  var width = _ref2.width;
  return width || 'auto';
}, function (_ref3) {
  var borderRadius = _ref3.borderRadius;
  return borderRadius || 0;
}, function (_ref4) {
  var _ref4$appearance = _ref4.appearance,
    appearance = _ref4$appearance === void 0 ? 'gray' : _ref4$appearance;
  return appearanceValues[appearance].background;
}, function (_ref5) {
  var _ref5$appearance = _ref5.appearance,
    appearance = _ref5$appearance === void 0 ? 'gray' : _ref5$appearance;
  return "linear-gradient(\n    to right,\n    transparent 0%,\n   ".concat(appearanceValues[appearance].animation, " 20%,\n    transparent 40%,\n    transparent 100%\n  )");
}, function (_ref6) {
  var height = _ref6.height,
    isShimmering = _ref6.isShimmering;
  return isShimmering ? "40px ".concat(height, ";") : '0px';
}, placeholderShimmer);

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var ShimmerSkeletonSpan = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\theight: ", ";\n\twidth: ", ";\n\tborder-radius: ", ";\n\tuser-select: none;\n\tbackground: ", ";\n\n\tbackground-image: ", ";\n\tbackground-repeat: no-repeat;\n\tbackground-size: ", ";\n\n\tanimation: ", " 1s linear infinite forwards;\n"])), function (_ref7) {
  var height = _ref7.height;
  return height || 'auto';
}, function (_ref8) {
  var width = _ref8.width;
  return width || 'auto';
}, function (_ref9) {
  var borderRadius = _ref9.borderRadius;
  return borderRadius || 0;
}, function (_ref10) {
  var _ref10$appearance = _ref10.appearance,
    appearance = _ref10$appearance === void 0 ? 'gray' : _ref10$appearance;
  return appearanceValues[appearance].background;
}, function (_ref11) {
  var _ref11$appearance = _ref11.appearance,
    appearance = _ref11$appearance === void 0 ? 'gray' : _ref11$appearance;
  return "linear-gradient(\n    to right,\n    transparent 0%,\n   ".concat(appearanceValues[appearance].animation, " 20%,\n    transparent 40%,\n    transparent 100%\n  )");
}, function (_ref12) {
  var height = _ref12.height,
    isShimmering = _ref12.isShimmering;
  return isShimmering ? "40px ".concat(height, ";") : '0px';
}, placeholderShimmer);
export var SpanSkeleton = function SpanSkeleton(_ref13) {
  var width = _ref13.width,
    _ref13$appearance = _ref13.appearance,
    appearance = _ref13$appearance === void 0 ? 'gray' : _ref13$appearance,
    _ref13$height = _ref13.height,
    height = _ref13$height === void 0 ? 14 : _ref13$height,
    _ref13$borderRadius = _ref13.borderRadius,
    borderRadius = _ref13$borderRadius === void 0 ? 0 : _ref13$borderRadius,
    _ref13$isShimmering = _ref13.isShimmering,
    isShimmering = _ref13$isShimmering === void 0 ? true : _ref13$isShimmering,
    testId = _ref13.testId,
    _ref13$style = _ref13.style,
    style = _ref13$style === void 0 ? {} : _ref13$style;
  return /*#__PURE__*/React.createElement(ShimmerSkeletonSpan, {
    width: typeof width === 'number' ? "".concat(width, "px") : width,
    height: typeof height === 'number' ? "".concat(height, "px") : height,
    borderRadius: typeof borderRadius === 'number' ? "".concat(borderRadius, "px") : borderRadius,
    appearance: appearance,
    isShimmering: isShimmering,
    "data-testid": testId
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,
    style: style
  });
};
export var Skeleton = function Skeleton(_ref14) {
  var width = _ref14.width,
    _ref14$appearance = _ref14.appearance,
    appearance = _ref14$appearance === void 0 ? 'gray' : _ref14$appearance,
    _ref14$height = _ref14.height,
    height = _ref14$height === void 0 ? 14 : _ref14$height,
    _ref14$borderRadius = _ref14.borderRadius,
    borderRadius = _ref14$borderRadius === void 0 ? 0 : _ref14$borderRadius,
    _ref14$isShimmering = _ref14.isShimmering,
    isShimmering = _ref14$isShimmering === void 0 ? true : _ref14$isShimmering,
    testId = _ref14.testId,
    _ref14$style = _ref14.style,
    style = _ref14$style === void 0 ? {} : _ref14$style;
  return /*#__PURE__*/React.createElement(ShimmerSkeleton, {
    width: typeof width === 'number' ? "".concat(width, "px") : width,
    height: typeof height === 'number' ? "".concat(height, "px") : height,
    borderRadius: typeof borderRadius === 'number' ? "".concat(borderRadius, "px") : borderRadius,
    appearance: appearance,
    isShimmering: isShimmering,
    "data-testid": testId
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,
    style: style
  });
};
export default Skeleton;